import React from 'react';
import { BaseField } from 'react/components/fields';
import PropTypes from 'prop-types';

const renderFieldContent = ({ id, input, disabled }) => (
  <input
    id={id}
    type="checkbox"
    checked={input.checked}
    value={input.value}
    onChange={(e) => {
      input.onBlur();
      input.onChange(e.target.checked);
    }}
    disabled={disabled}
  />
);

const gridFormatter = ({ label, name }) => ({
  id: name,
  name,
  label,
  type: 'CHECKBOX'
});

const CheckboxField = (props) => {
  const { defaultValue, customClassName } = props;
  return (
    <BaseField
    fieldClassName={`checkboxField ${customClassName || ''}`}
      renderFieldContent={renderFieldContent}
      gridFormatter={gridFormatter}
      type="checkbox"
      defaultValue={defaultValue}
      {...props}
    />
  );
};

renderFieldContent.propTypes = {
  id: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  disabled: PropTypes.bool
};

renderFieldContent.defaultProps = {
  disabled: false
};

CheckboxField.propTypes = {
  defaultValue: PropTypes.bool
};

CheckboxField.defaultProps = {
  defaultValue: false
};

export default CheckboxField;
